import { render } from "./B2CMaxRequestPopup.vue?vue&type=template&id=2124b9be&lang=pug"
import script from "./B2CMaxRequestPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./B2CMaxRequestPopup.vue?vue&type=script&setup=true&lang=js"

import "./B2CMaxRequestPopup.vue?vue&type=style&index=0&id=2124b9be&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__